<span *ngIf="declaracao">
  {{declaracao.descricao}}
  <span *ngIf="declaracao.marca"> / {{declaracao.marca}}</span>
  <span *ngIf="declaracao.modelo"> / {{declaracao.modelo}}</span>
</span>
